import base from './Base';
import depth from './Depth';
import width from './Width';
import feetAndCasters from './FeetAndCasters';
import workSurface from './WorkSurface';
import uprights from './Uprights';
import uprightPosition from './UprightPosition';
import shelvingPosition from './ShelvingPosition';
import aboveOverheadShelving from './AboveOverheadShelving';
import aboveUprightShelving from './AboveUprightShelving';
import belowShelving from './BelowShelving';
import dividers from './Dividers';
import shelvingLights from './ShelvingLights';
import shelvingAddOns from './ShelvingAddOns';
import computerPosition from './ComputerPosition';
import powerAndLightPosition from './PowerAndLightPosition';
import uprightTaskLight from './UprightTaskLight';
import belowPower from './BelowPower';
import abovePowerAndLightAddOns from './AbovePowerAndLightAddOns';
import powerAddOns from './PowerAddOns';
import toolSupportPosition from './ToolSupportPosition';
import aboveAdditionalToolSupport from './AboveAdditionalToolSupport';
import aboveToolAddOns from './AboveToolAddOns';
import aboveBinRailAddOns from './AboveBinRailAddOns';
import popularPosition from './PopularPosition';
import belowPopularBackstop from './BelowPopularBackstop';
import belowPopularFootrest from './BelowPopularFootrest';
import colorPaint from './ColorPaint';
import colorStandardLaminate from './ColorLaminate';
import aboveOverheadLight from './AboveOverheadLight';
import aboveAdditionalToolAddOns from './AboveToolAddOns';
import aboveMonitorArmAccessary from './AboveMonitorArmAccessary';

export default {
  base,
  depth,
  width,
  feetAndCasters,
  workSurface,
  uprights,
  uprightPosition,
  shelvingPosition,
  aboveOverheadShelving,
  aboveUprightShelving,
  belowShelving,
  dividers,
  shelvingLights,
  shelvingAddOns,
  computerPosition,
  powerAndLightPosition,
  uprightTaskLight,
  aboveOverheadLight,
  belowPower,
  abovePowerAndLightAddOns,
  powerAddOns,
  toolSupportPosition,
  aboveAdditionalToolSupport,
  aboveToolAddOns,
  aboveAdditionalToolAddOns,
  aboveBinRailAddOns,
  popularPosition,
  belowPopularBackstop,
  belowPopularFootrest,
  colorStandardPaint: colorPaint,
  // colorPremiumPaint: colorPaint,
  colorStandardLaminate,
  aboveMonitorArmAccessary,
};



// WEBPACK FOOTER //
// ./src/components/Attributes/nonStandardAttributes/index.js